import React from "react";
// nodejs library that concatenates classes
import classNames from "classnames";

// @mui/icons-material
import GridContainer from "components/Grid/GridContainer.js";
import GridItem from "components/Grid/GridItem.js";
import Quote from "components/Typography/Quote.js";
// core components


import { TwitterTimelineEmbed, TwitterShareButton, TwitterFollowButton, TwitterHashtagButton, TwitterMentionButton, TwitterTweetEmbed, TwitterMomentShare, TwitterDMButton, TwitterVideoEmbed, TwitterOnAirButton } from 'react-twitter-embed';
import Card from '@mui/material/Card';
import CardActionArea from '@mui/material/CardActionArea';
import CardActions from '@mui/material/CardActions';
import CardContent from '@mui/material/CardContent';
import CardMedia from '@mui/material/CardMedia';
import Button from '@mui/material/Button';
import Typography from '@mui/material/Typography';
import styles from "../../../../services/ServicesSections.module.scss";




export default function SectionText() {
  const classes = styles;
  const imgClasses = classNames(
    classes.imgRaised,
    classes.imgRounded,
    classes.imgFluid
  );
  return (
    <div className={classes.section}>
      <GridContainer justifyContent="center">
 
        
        <GridItem xs={12} sm={8} md={8}>
        <a className={classes.anchor} id="start"></a>
          <h3 className={classes.title}>Measurecamp 2016 - Attribution And Military Tactics In Digital Marketing</h3>
          <p> 
            Here is my presentation from Measurecamp Sydney 2016. The talk introduces some of the mathematics behind attribution and in particular the "random" factors that cannot be accounted for under any model. These factos could be anything - frokm word of mouth, the weather, or whether said user was having a bad day (or set of days!) or not.
            <br /><br />  
            The talk then delves into the guts of the presentation - introducing the thoughts of 3 military writers/commenders: Sun Tzu, Carl Von Clasewitz and Donald Rumsfeld. Using the learnings from these and other commanders - the talk describes spefic military tactics that are applicable to marketing strategy.          
            <br /><br />  
          </p>
 
          </GridItem>

          <GridItem xs={12} sm={10} md={10}>
                <Card
                  raised
                  //background
                  //style={{
                  //  backgroundImage: "url('/img/sections/services/google-analytics-training/1.jpg')",
                  //}}
                >
                  
                  <CardActionArea>
                    <CardMedia
                      component="iframe"
                      alt="Contemplative Reptile"
                      //className={classes.media}
                      height="500"
                      image="https://docs.google.com/presentation/d/e/2PACX-1vRMxdeQ3-p5u8mqK2oK3R77VI82S7NLeAT7tBNUwYMMyUfXbu1QoBFNEhVycHJAJSoeTaq-OrxO7krH/embed?start=false&loop=false&delayms=3000"
                      //title="Contemplative Reptile"
                    />

                  </CardActionArea>
                </Card>  
                <p><br /><br /></p>       
              </GridItem>
          

        


      </GridContainer>
    </div>

  );
}
